import { defineStore } from 'pinia';
import Evaluations from 'src/boot/services/Evaluations';
import { EvaluationTree } from 'src/types';

export const useEvaluations = defineStore('evaluations', {
  state: () => ({
    evaluationsTree: [] as EvaluationTree[],
    suggestedEvaluationTree: [] as EvaluationTree[],
    filteredEvaluations: [] as EvaluationTree[],
    suggestedSubjects: [] as string[],
  }),
  getters: {},
  actions: {
    async fetchEvaluationHistoryTree() {
      const tree = await Evaluations.fetchEvaluationHistoryTree();
      this.$state.evaluationsTree = tree || [];
      await this.fetchSuggestedByCycle();
    },
    async fetchSuggestedSubjects() {
      const subjects = await Evaluations.fetchSuggestedSubjects();
      this.$state.suggestedSubjects = subjects || [];
    },
    async fetchSuggestedByCycle() {
      if(!this.suggestedSubjects.length)
        await this.fetchSuggestedSubjects();
      const filteredSubjectsTree = this.$state.evaluationsTree.filter(
        (evaluation: EvaluationTree) => {
          return this.$state.suggestedSubjects.includes(evaluation.subject);
        }
      );
      this.$state.suggestedEvaluationTree = filteredSubjectsTree;
    },
    async updateSuggestedSubjects(subjects: string[]) {
      if(!subjects.length) return;
      this.$state.suggestedSubjects = subjects;
      await this.fetchSuggestedByCycle();
    }
  },
});
